export { normalizeExperienceLocationType } from './experience-location-type.ts';
